import { Divider } from '@mui/material';

import { SectionSkeleton } from 'components/shared/MultiStepForm/Skeletons/SectionSkeleton';

const FormSkeleton = () => (
  <div>
    <SectionSkeleton height={230} width={835} />
    <Divider />
    <SectionSkeleton height={210} width={835} />
    <Divider />
    <SectionSkeleton height={60} width={835} />
  </div>
);

export default FormSkeleton;
